import React, { Component } from "react";
import { v4 } from "uuid";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Modal from "react-bootstrap/Modal";

import "./NewTemplate.scss";
import TemplateHeader from "./Template/TemplateHeader";
import TemplateFooter from "./Template/TemplateFooter";
import TabName from "./TabsNavigation/TabName";
import Tools from "./Tools/Tools";
import TabsNavigation from "./TabsNavigation/TabsNavigation";
import SectionTitle from "./SectionContent/SectionTitle";
import SectionContent from "./SectionContent/SectionContent";
import ViewMode from "./ViewMode/ViewMode";
import TabDeleteModal from "./TabsNavigation/TabDeleteModal";
import { notify } from "../../Notify/Notify";
import VerticalGroupBar from "./VerticalGroupBar";
import EditDocumentTemplate from "../EditDocumentName/EditDocumentTemplate";

const CategoryA = ["TextField", "TextArea", "Number"];
const CategoryB = ["Dropdown", "Checkbox", "Radio"];
class NewTemplate extends Component {
  state = {
    content: this.props.content,
    activeTab: null,
    activeTabSection: [],
    currentTabName: "",
    currentSection: null,
    editView: true,
    showTabDeleteModal: false,
    errors: {},
    currentFieldId: null,
    isautoScroll: true,
    flag: true,
    autoSave: false,
    autoSaveFlag: true,
    createFlag: false,
    templateTitle: "",
    showTabEditModal: false,
    templateDescription: "",
    errorName: "",
    documentDescription: "",
  };

  //  autoSave : start activating auto saving. true(start auto save function call using setInterval method) / False( stop calling auto save function clearInterval)
  //  autoSaveFlag : true(call handleAutoSave() function only once) / false(after first execution make it as false to avoid forking function calls)
  //  stopUpdate : when we do autosave, avoid doing state update in comonentDidUpdate to skip state update and prevent page reloading
  //  createFlag : when document is created first time,only than make this as true to call create new temp api / false : call update temp api

  componentDidMount() {
    this.setState({
      autoSave: false,
      stopFlag: true,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      if (this.props.stopUpdate) {
        this.setState({
          stopFalg: false,
          createFlag: false,
        });
      } else {
        if (this.props.editTemplate) {
          this.setState(
            {
              content: this.props.content,
              activeTab: this.props.content[0].tabId,
              activeTabSection: this.props.content[0].tabSections,
              currentTabName: this.props.content[0].tabTitle,
              currentSection: this.props.content[0].tabSections[0].sectionId,
              currentFieldId:
                this.props.content[0].tabSections[0].sectionFields[0].fieldId,
              editView: true,
              documentTitle: this.props.templateTitle,
              documentDescription: this.props.documentDescription,
              templateTitle: this.props.templateTitle,
              templateDescription: this.props.documentDescription,
              autoSave: this.props.autoSave,
              autoSaveFlag: this.props.autoSaveFlag,
              stopFlag: true,
              createFlag: false,
            },
            () => {
              if (this.state.autoSaveFlag) {
                this.handleAutoSave();
              }
            }
          );
        } else {
          this.setState(
            {
              content: this.props.content,
              activeTab: null,
              activeTabSection: [],
              currentTabName: "",
              currentSection: null,
              editView: true,
              errors: {},
              autoSave: this.props.autoSave,
              autoSaveFlag: this.props.autoSaveFlag,
              stopFlag: true,
              documentTitle: this.props.templateTitle,
              documentDescription: this.props.documentDescription,
              templateDescription: this.props.documentDescription,
              templateTitle: this.props.templateTitle,
            },
            () => {
              if (this.props.autoSave) {
                this.setState(
                  {
                    createFlag: true,
                  },
                  () => this.handleAutoSave()
                );
              } else {
                this.handleAutoSave();
              }
              this.addTabHandler();
            }
          );
        }
      }
    }
  }

  /* CHANGE */
  // TAB
  handleAutoSave() {
    if (this.state.autoSave) {
      this.setState(
        {
          autoSaveFlag: false,
        },
        () =>
          (this.autoSaveCallBack = setInterval(
            () => this.autoSaveFunc(this.state.createFlag),
            60000
          ))
      );
    } else {
      if (this.autoSaveCallBack) {
        clearInterval(this.autoSaveCallBack);
      }
    }
  }

  autoSaveFunc(flag) {
    if (flag) {
      this.setState({
        createFlag: false,
      });
    }
    const updatedsection = this.updateContent();
    // this.validate();
    // if (this.hasValidValue()) {
    //     this.props.templateAutoSaveHandler(updatedsection,1);
    // }
    // else{
    this.props.templateAutoSaveHandler(
      updatedsection,
      this.state.documentTitle,
      this.state.documentDescription,
      2,
      flag
    );

    // }
  }
  changeTabHandler = (id, tabSection) => {
    let updatedContent = [...this.state.content];
    let tabName;
    let sectionId = null;
    let field = null;
    const updatedsection = updatedContent.map((item) => {
      let resultcontent = item;
      if (item.tabId === this.state.activeTab) {
        resultcontent.tabSections = this.state.activeTabSection;
      }
      if (id === item.tabId) {
        tabName = item.tabTitle;
        if (item.tabSections.length > 0) {
          sectionId = item.tabSections[0].sectionId;
          field = item.tabSections[0].sectionFields[0].fieldId;
        }
      }
      return resultcontent;
    });
    this.setState(
      {
        content: updatedsection,
        activeTab: id,
        activeTabSection: tabSection,
        currentTabName: tabName,
        currentSection: sectionId,
        showTabDeleteModal: false,
        currentFieldId: field,
      },
      () => {
        let ID = "#v" + this.state.activeTabSection[0].sectionId;
        const anchor = document.querySelector(ID);
        if (anchor) {
          anchor.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    );
  };

  // SECTION
  changeSectionHandler = (flag, id) => {
    if (flag) {
      this.setState({ currentSection: id }, () => this.updateSectionField());
    }
  };

  updateSectionField() {
    const obj = this.state.activeTabSection.find(
      (element) => element.sectionId === this.state.currentSection
    );
    if (obj) {
      this.setState(
        {
          currentFieldId: obj.sectionFields.length === 0 ? null : obj.sectionFields[0].fieldId,
        },
        () => {
          if (this.state.isautoScroll) {
            this.autoScroll();
          }
        }
      );
    }
  }
  // VIEW
  toggleEditHandler = () => {
    this.validate();
    // const content = this.updateContent();
    const editView = true;
    this.setState({ editView });
  };

  toggleViewHandler = () => {
    this.validate();
    // const content = this.updateContent();
    if (this.hasValidValue()) {
      const editView = false;
      this.setState({ editView });
    }
  };
  /* ADD */

  // TAB
  addTabHandler = () => {
    const tabId = v4();
    const sectionId = v4();
    const fieldId = v4();
    // default TextField
    const sectionFields = [
      {
        fieldId: fieldId,
        fieldLabel: "",
        inputType: "TextField",
        fieldRequired: false,
        fieldPlaceHolder: "",
      },
    ];
    // default SectionField
    const tabSection = [
      {
        sectionId: sectionId,
        sectionTitle: "",
        sectionFields: sectionFields,
      },
    ];

    const updatedTab = [
      ...this.state.content,
      {
        tabId: tabId,
        tabTitle: "Tab Name",
        tabSections: tabSection,
      },
    ];
    this.changeTabHandler(tabId, tabSection);
    let element = this.state.errors;
    element[tabId] = false;
    element[sectionId] = false;
    this.setState({
      content: updatedTab,
      currentTabName: "",
      currentSection: sectionId,
      errors: element,
      currentFieldId: fieldId,
    });
  };

  //  SECTION
  addSectionHandler = () => {
    const sectionId = v4();
    const fieldId = v4();
    const sectionFields = [
      {
        fieldId: fieldId,
        fieldLabel: "",
        inputType: "TextField",
        fieldRequired: false,
        fieldPlaceHolder: "",
      },
    ];
    const updatedSection = [
      ...this.state.activeTabSection,
      {
        sectionId: sectionId,
        sectionTitle: "",
        sectionFields: sectionFields,
      },
    ];
    let element = this.state.errors;
    element[sectionId] = false;
    this.setState(
      {
        activeTabSection: updatedSection,
        currentSection: sectionId,
        errors: element,
      },
      () => {
        this.autoScroll();
      }
    );
  };

  autoScroll() {
    const obj = this.state.activeTabSection.find(
      (element) => element.sectionId === this.state.currentSection
    );
    this.setState({
      currentFieldId: obj.sectionFields.length === 0 ? null : obj.sectionFields[0].fieldId,
    });
    const ID = "#v" + this.state.currentSection;
    const anchor = document.querySelector(ID);
    anchor.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  // TEXT FIELD, TEXT AREA, NUMBER FIELD
  addFieldHandler = (type) => {
    let updatedactiveTabSection = [...this.state.activeTabSection];
    let addType;
    switch (type) {
      case "TextField":
        addType = "TextField";
        break;
      case "TextArea":
        addType = "TextArea";
        break;
      case "Number":
        addType = "Number";
        break;
      default:
        addType = type;
    }
    const fieldId = v4();
    const findId = "#a" + fieldId;
    let updatedSection = updatedactiveTabSection.map((item) => {
      let resultItem = item;
      if (resultItem.sectionId === this.state.currentSection) {
        resultItem.sectionFields = [
          ...resultItem.sectionFields,
          {
            fieldId: "a" + fieldId,
            fieldLabel: "",
            inputType: addType,
            fieldRequired: false,
            fieldPlaceHolder: "",
          },
        ];
      }
      return resultItem;
    });
    let element = this.state.errors;
    element[fieldId] = false;
    this.setState(
      {
        activeTabSection: updatedSection,
        errors: element,
        currentFieldId: "a" + fieldId,
      },
      () => {
        this.handleSectionScroll(findId);
      }
    );
  };

  handleSectionScroll(findId) {
    const anchor = document.querySelector(findId);
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  // CHECKBOX, DROPDOWN, RADIO
  addOptionTypeFieldHandler = (type) => {
    let updatedactiveTabSection = [...this.state.activeTabSection];
    let addType;

    switch (type) {
      case "Checkbox":
        addType = "Checkbox";
        break;
      case "Dropdown":
        addType = "Dropdown";
        break;
      case "Radio":
        addType = "Radio";
        break;
      default:
        addType = type;
    }
    const fieldId = v4();
    const findId = "#a" + fieldId;

    let updatedSection = updatedactiveTabSection.map((item) => {
      let resultItem = item;
      if (resultItem.sectionId === this.state.currentSection) {
        resultItem.sectionFields = [
          ...resultItem.sectionFields,
          {
            fieldId: "a" + fieldId,
            fieldLabel: "",
            inputType: addType,
            fieldRequired: false,
            options: [{ optionId: v4(), optionValue: "" }],
          },
        ];
      }
      return resultItem;
    });
    this.setState(
      { activeTabSection: updatedSection, currentFieldId: "a" + fieldId },
      () => {
        this.handleSectionScroll(findId);
      }
    );
  };

  // DATE FIELD
  addDateHandler = () => {
    const fieldId = v4();
    const findId = "#a" + fieldId;
    let updatedactiveTabSection = [...this.state.activeTabSection];
    let updatedSection = updatedactiveTabSection.map((item) => {
      let resultItem = item;
      if (resultItem.sectionId === this.state.currentSection) {
        resultItem.sectionFields = [
          ...resultItem.sectionFields,
          {
            fieldId: "a" + fieldId,
            fieldLabel: "",
            inputType: "Date",
            fieldRequired: false,
            setReminder: false,
            fieldDescription: "",
          },
        ];
      }
      return resultItem;
    });
    this.setState(
      { activeTabSection: updatedSection, currentFieldId: "a" + fieldId },
      () => {
        this.handleSectionScroll(findId);
      }
    );
  };

  // OPTION
  addOptionHandler = (id) => {
    let updatedSection = [...this.state.activeTabSection];
    let updatedField = updatedSection.map((section) => {
      let resultSection = section;
      if (resultSection.sectionId === this.state.currentSection) {
        resultSection.sectionFields.map((field) => {
          let updatedField = field;
          if (updatedField.fieldId === id) {
            updatedField.options = [
              ...updatedField.options,
              { optionId: v4(), optionValue: "" },
            ];
          }
          return updatedField;
        });
      }
      return resultSection;
    });
    this.setState({ activeTabSection: updatedField });
  };

  /* UPDATE */

  // TAB NAME
  updateTabNameHandler = (event) => {
    let updatedContent = [...this.state.content];

    let updatedTitle = updatedContent.map((item) => {
      let resultcontent = item;
      if (resultcontent.tabId === this.state.activeTab) {
        resultcontent.tabTitle = event.target.value
          ? event.target.value
          : "Tab Name";
      }
      return resultcontent;
    });
    this.validate();
    this.setState({
      content: updatedTitle,
      currentTabName: event.target.value,
    });
  };

  // SECTION NAME
  updateSectionNameHandler = (event, id) => {
    const updatedSection = [...this.state.activeTabSection];
    const updatedTitle = updatedSection.map((section) => {
      let resultSection = section;
      if (resultSection.sectionId === id) {
        resultSection.sectionTitle = event.target.value;
      }
      return resultSection;
    });
    this.validate();
    this.setState({ activeTabSection: updatedTitle });
  };

  // LABEL, PLACEHOLDER, REQUIRED
  updatedField = (event, id, updateType) => {
    let updatedSection = [...this.state.activeTabSection];
    let updatedField = updatedSection.map((section) => {
      let resultSection = section;
      if (resultSection.sectionId === this.state.currentSection) {
        resultSection.sectionFields.map((field) => {
          let updatedField = field;
          if (updatedField.fieldId === id) {
            if (updateType === "Label") {
              updatedField.fieldLabel = event.target.value;
            } else if (updateType === "PlaceHolder") {
              updatedField.fieldPlaceHolder = event.target.value;
            } else if (updateType === "Description") {
              updatedField.fieldDescription = event.target.value;
            } else if (updateType === "Required") {
              updatedField.fieldRequired = !field.fieldRequired;
              if (!field.fieldRequired) {
                updatedField.setReminder = false;
              }
            } else if (updateType === "Reminder") {
              updatedField.setReminder = !field.setReminder;
              if (field.setReminder) {
                updatedField.fieldRequired = true;
              }
            } else {
              updatedField = field;
            }
          }
          return updatedField;
        });
      }
      return resultSection;
    });
    this.validate();
    this.setState({ activeTabSection: updatedField });
  };

  // OPTION NAME
  updateOptionValue = (event, id) => {
    let updatedSection = [...this.state.activeTabSection];
    let updatedField = updatedSection.map((section) => {
      let resultSection = section;
      if (resultSection.sectionId === this.state.currentSection) {
        resultSection.sectionFields.map((field) => {
          if (field.options) {
            field.options.map((option) => {
              let result = option;
              if (result.optionId === id) {
                result.optionValue = event.target.value;
              }
              return result;
            });
          }
          return true;
        });
      }
      return resultSection;
    });
    this.validate();
    this.setState({ activeTabSection: updatedField });
  };

  /* DELETE */

  // TAB
  deleteTabHandler = () => {
    if (this.state.content.length > 1) {
      let tabId;
      let tabSection;
      let updatedContent = [...this.state.content];
      const index = updatedContent.findIndex(
        (tab) => tab.tabId === this.state.activeTab
      );
      const sectionIdList = [];
      this.state.activeTabSection.map((item) => {
        sectionIdList.push(item.sectionId);
        item.sectionFields.map((field) => sectionIdList.push(field.fieldId));
        return true;
      });
      updatedContent.splice(index, 1);
      if (index > -1 && updatedContent.length > 0) {
        tabId = updatedContent[0].tabId;
        tabSection = updatedContent[0].tabSections;
      } else {
        tabId = null;
        tabSection = [];
      }

      const detail = "Success";
      const title = this.state.currentTabName
        ? this.state.currentTabName + " tab deleted successfully!"
        : "Tab deleted successfully!";
      const type = "success";
      notify(detail, title, type);

      this.changeTabHandler(tabId, tabSection);

      // deleteing id's from errors state
      let element = this.state.errors;
      delete element[this.state.activeTab];
      sectionIdList.map((id) => delete element[id]);

      this.setState({
        content: updatedContent,
        activeTab: tabId,
        activeTabSection: tabSection,
        errors: element,
        showTabDeleteModal: false,
      });
    }
  };

  // SECTION
  deleteSectionHandler = (id) => {
    if (this.state.activeTabSection.length > 1) {
      let SectionId;
      let updatedTabSection = [...this.state.activeTabSection];
      const index = updatedTabSection.findIndex(
        (section) => section.sectionId === id
      );
      const fieldIdList = [];
      this.state.activeTabSection.map((item) => {
        if (item.sectionId === id) {
          item.sectionFields.map((field) => fieldIdList.push(field.fieldId));
        }
        return true;
      });
      updatedTabSection.splice(index, 1);
      if (index > -1 && updatedTabSection.length > 0) {
        SectionId = updatedTabSection[0].sectionId;
      } else {
        SectionId = null;
      }

      let element = this.state.errors;
      delete element[id];
      fieldIdList.map((id) => delete element[id]);

      this.setState(
        {
          activeTabSection: updatedTabSection,
          errors: element,
        },
        () => this.changeSectionHandler(this.state.flag, SectionId)
      );
    }
  };

  // FIELD
  deleteFieldHandler = (id) => {
    let selectedSectionId = this.state.activeTabSection.map((section) => {
      if (section.sectionFields.find((fields) => fields.fieldId === id)) {
        return section.sectionId;
      }
      return null;
    });
    let selectedId = selectedSectionId.find((e) => e !== null);
    let updatedTabSection = [...this.state.activeTabSection];
    let mainSection = null;
    let index = null;
    const updatedSection = updatedTabSection.map((section) => {
      let resultedSection = section;
      if (resultedSection.sectionId === selectedId) {
        index = resultedSection.sectionFields.findIndex(
          (field) => field.fieldId === id
        );
        mainSection = resultedSection.sectionFields;
        resultedSection.sectionFields.splice(index, 1);
      }
      return resultedSection;
    });
    let activeField = mainSection[index - 1].fieldId;
    let element = this.state.errors;
    delete element[id];
    this.setState(
      {
        activeTabSection: updatedSection,
        errors: element,
      },
      () => {
        this.setState({
          currentFieldId: activeField,
        });
      }
    );
  };

  // OPTION
  deleteOptionsHandler = (fieldId, optionId, sectionId) => {
    let updatedTabSection = [...this.state.activeTabSection];
    updatedTabSection.map((section) => {
      let resultSection = section;
      if (resultSection.sectionId === this.state.currentSection) {
        resultSection.sectionFields.map((field) => {
          let result = field;
          if (result.fieldId === fieldId) {
            const index = result.options.findIndex(
              (option) => option.optionId === optionId
            );
            result.options.splice(index, 1);
          }
          return result;
        });
        return resultSection;
      }
      return true;
    });
  };

  /* DRAG THE FIELD ITEMS */
  onDragEnd = (result) => {
    if (!result.destination) return;

    const { source, destination } = result;
    const allSection = [...this.state.activeTabSection];

    const sourceSection = allSection.find(
      (section) => section.sectionId === source.droppableId
    );
    const destinationSection = allSection.find(
      (section) => section.sectionId === destination.droppableId
    );

    const sourceContent = sourceSection.sectionFields;
    const destinationContent = destinationSection.sectionFields;

    const [removed] = sourceContent.splice(source.index, 1);
    destinationContent.splice(destination.index, 0, removed);

    sourceSection.sectionFields = sourceContent;
    destinationSection.sectionFields = destinationContent;

    const updatedSections = allSection.map((section) => {
      if (section.SectionId === source.droppableId) {
        section = sourceContent;
      }

      if (section.SectionId === destination.droppableId) {
        section = destinationContent;
      }

      return section;
    });

    this.setState(
      {
        activeTabSection: updatedSections,
      },
      () => {
        this.setState({ currentFieldId: result.draggableId });
      }
    );
  };
  /* COPY FIELD */

  copyFieldHandler = (fieldId, type, sectionId) => {
    const allSection = [...this.state.activeTabSection];
    let activeSection = allSection.find((section) => {
      return section.sectionId === sectionId;
    });
    if (activeSection) {
      const updatedSectionContent = activeSection.sectionFields;
      const index = updatedSectionContent.findIndex(
        (field) => field.fieldId === fieldId
      );
      const currentField = updatedSectionContent[index];
      let newFieldAdd;
      let newId = "a" + v4();
      if (["Dropdown", "Checkbox", "Radio"].includes(type)) {
        const currentOptions = currentField.options;
        let newOptions = [];
        currentOptions.forEach((element) => {
          newOptions.push({ ...element, optionId: v4() });
        });

        newFieldAdd = {
          fieldId: newId,
          fieldLabel: currentField.fieldLabel,
          inputType: currentField.inputType,
          fieldRequired: currentField.fieldRequired,
          options: newOptions,
        };
      } else if (type in ["TextField", "TextArea", "Number"]) {
        newFieldAdd = {
          fieldId: newId,
          inputType: currentField.inputType,
          fieldLabel: currentField.fieldLabel,
          fieldRequired: currentField.fieldRequired,
          fieldPlaceHolder: currentField.fieldPlaceHolder,
        };
      } else {
        newFieldAdd = {
          fieldId: newId,
          inputType: currentField.inputType,
          fieldLabel: currentField.fieldLabel,
          fieldRequired: currentField.fieldRequired,
          setReminder: currentField.setReminder,
          fieldPlaceHolder: currentField.fieldPlaceHolder,
        };
      }
      updatedSectionContent.splice(index + 1, 0, newFieldAdd);
      activeSection.sectionFields = updatedSectionContent;
      let updatedSection = allSection.map((item) => {
        let resultSection = item;
        if (resultSection.SectionId === this.state.currentSection) {
          resultSection = updatedSectionContent;
        }
        return resultSection;
      });

      this.setState(
        {
          activeTabSection: updatedSection,
          currentSection: sectionId,
        },
        () => {
          this.setState(
            {
              currentFieldId: newId,
            },
            () => this.handleSectionScroll("#" + newId)
          );
        }
      );
    }
  };

  changeFieldHandler = (event, fieldId, type, sectionId) => {
    const allSection = [...this.state.activeTabSection];
    let activeSection = allSection.find((section) => {
      return section.sectionId === sectionId;
    });
    if (activeSection) {
      const updatedSectionContent = activeSection.sectionFields;
      const index = updatedSectionContent.findIndex(
        (field) => field.fieldId === fieldId
      );
      const currentField = updatedSectionContent[index];
      let newFieldAdd;
      const newType = event.target.value;
      let newId = "a" + v4();
      if (CategoryA.includes(type)) {
        if (CategoryA.includes(newType)) {
          newFieldAdd = {
            fieldId: newId,
            fieldLabel: currentField.fieldLabel,
            inputType: newType,
            fieldRequired: currentField.fieldRequired,
            fieldPlaceHolder: currentField.fieldPlaceHolder,
          };
        } else if (CategoryB.includes(newType)) {
          newFieldAdd = {
            fieldId: newId,
            fieldLabel: currentField.fieldLabel,
            inputType: newType,
            fieldRequired: currentField.fieldRequired,
            options: [{ optionId: v4(), optionValue: "" }],
          };
        } else {
          newFieldAdd = {
            fieldId: newId,
            fieldLabel: currentField.fieldLabel,
            inputType: newType,
            fieldRequired: currentField.fieldRequired,
            setReminder: false,
            fieldPlaceHolder: " ",
          };
        }
      } else if (CategoryB.includes(type)) {
        if (CategoryA.includes(newType)) {
          newFieldAdd = {
            fieldId: newId,
            fieldLabel: currentField.fieldLabel,
            inputType: newType,
            fieldRequired: currentField.fieldRequired,
            fieldPlaceHolder: " ",
          };
        } else if (CategoryB.includes(newType)) {
          const currentOptions = currentField.options;
          let newOptions = [];
          currentOptions.forEach((element) => {
            newOptions.push({ ...element, optionId: v4() });
          });
          newFieldAdd = {
            fieldId: newId,
            fieldLabel: currentField.fieldLabel,
            inputType: newType,
            fieldRequired: currentField.fieldRequired,
            options: newOptions,
          };
        } else {
          newFieldAdd = {
            fieldId: newId,
            fieldLabel: currentField.fieldLabel,
            inputType: newType,
            fieldRequired: currentField.fieldRequired,
            setReminder: false,
            fieldPlaceHolder: " ",
          };
        }
      } else {
        if (CategoryA.includes(newType)) {
          newFieldAdd = {
            fieldId: newId,
            fieldLabel: currentField.fieldLabel,
            inputType: newType,
            fieldRequired: currentField.fieldRequired,
            fieldPlaceHolder: " ",
          };
        } else {
          newFieldAdd = {
            fieldId: newId,
            fieldLabel: currentField.fieldLabel,
            inputType: newType,
            fieldRequired: currentField.fieldRequired,
            options: [{ optionId: v4(), optionValue: "" }],
          };
        }
      }

      updatedSectionContent.splice(index, 1);
      updatedSectionContent.splice(index, 0, newFieldAdd);
      activeSection.sectionFields = updatedSectionContent;
      let updatedSection = allSection.map((item) => {
        let resultSection = item;
        if (resultSection.SectionId === sectionId) {
          resultSection = updatedSectionContent;
        }
        return resultSection;
      });

      // update the state
      this.setState({
        activeTabSection: updatedSection,
        currentFieldId: newId,
        currentSection: sectionId,
      });
    }
  };

  // validate
  validate = () => {
    let content = this.updateContent();
    let errors = this.state.errors;
    const restrictedTitle = ["overview", "comment", "notes"];
    let allTabName = [];
    content.map((tabItem) => allTabName.push(tabItem.tabTitle));

    content.map((tab) => {
      const restrictedTabErrorId = tab.tabId + "restricted";
      const uniqueTabErrorId = tab.tabId + "unique";
      errors[restrictedTabErrorId] = restrictedTitle.includes(
        tab.tabTitle.toLowerCase()
      )
        ? true
        : false;
      errors[uniqueTabErrorId] =
        allTabName.filter(
          (tabName) => tabName.toLowerCase() === tab.tabTitle.toLowerCase()
        ).length > 1
          ? true
          : false;
      errors[tab.tabId] = tab.tabTitle === "Tab Name" ? true : false;
      tab.tabSections.map((section) => {
        errors[section.sectionId] =
          section.sectionTitle.length > 0 ? false : true;
        section.sectionFields.map((field) => {
          errors[field.fieldId] = field.fieldLabel.length > 0 ? false : true;

          field.options &&
            field.options.map((option) => {
              errors[option.optionId] =
                option.optionValue.length > 0 ? false : true;
              return true;
            });
          return true;
        });
        return true;
      });
      return true;
    });
    this.setState({ errors });
  };

  hasValidValue = () => {
    let errors = this.state.errors;
    let isValid = true;
    Object.keys(errors).map((item) => {
      if (errors[item]) {
        isValid = false;
      }
      return true;
    });
    return isValid;
  };

  // Create Template or Draft Template

  /* update the current content*/
  updateContent = () => {
    let updatedContent = [...this.state.content];
    const updatedsection = updatedContent.map((item) => {
      let resultcontent = item;
      if (item.tabId === this.state.activeTab) {
        resultcontent.tabSections = this.state.activeTabSection;
      }

      // Filter out sections which have no fields present. This scenario could occur since TE-1
      resultcontent.tabSections = resultcontent.tabSections.filter(s => s.sectionFields.length)

      return resultcontent;
    });

    this.setState({
      content: updatedsection,
    });
    return updatedsection;
  };

  createTemplateHandler = (e) => {
    // this.setState({
    //   autoSave : false,
    // })

    this.validate();
    if (this.hasValidValue()) {
      const updatedsection = this.updateContent();
      this.props.templateCreateHandler(
        e,
        updatedsection,
        this.state.documentTitle,
        this.state.templateDescription
      );
    }
  };

  draftTemplateHandler = (e) => {
    this.setState({
      autoSave: false,
    });
    // this.validate();
    // if (this.hasValidValue()) {
    const updatedsection = this.updateContent();
    this.props.templateSaveDraftHandler(
      e,
      updatedsection,
      this.state.documentTitle,
      this.state.templateDescription
    );
    // }
  };

  handleCallback = (childData) => {
    this.setState({ currentSection: childData }, () => {
      const obj = this.state.activeTabSection.find(
        (element) => element.sectionId === this.state.currentSection
      );
      this.setState(
        {
          currentFieldId: obj.sectionFields[0].fieldId,
        },
        () => this.autoScroll()
      );
    });
  };

  updateFieldIdHandler(e, ID, secId) {
    e.stopPropagation();
    this.setState({
      currentFieldId: ID,
      currentSection: secId,
    });
  }
  handleOpen = () => {
    this.setState({
      showTabEditModal: true,
    });
  };
  // Close the create a new template modal
  handleClose = () => {
    this.setState({ showTabEditModal: false });
  };

  handleInputValueChange = (e) => {
    this.setState({
      errorName: "",
    });

    this.setState({ [e.target.name]: e.target.value });
    if (e.target.name === "templateTitle") {
      if (e.target.value.length === 0) {
        this.setState({
          errorName: "Template name can not be blank.",
        });
      } else {
        this.props.DocumentTemplates.map((item) => {
          if (item.title.toLowerCase() === e.target.value.toLowerCase()) {
            this.setState({
              errorName: "Template name already exists.",
            });
          }
          return true;
        });
      }
    }

    if (e.target.name === "templateDescription") {
      if (e.target.value.length === 0) {
        this.setState({
          errorName: "Template description can not be blank.",
        });
      }
    }
  };

  render() {
    return (
      <Modal
        className="create-template-modal"
        size="xl"
        centered
        show={this.props.displayCreateModal}
        onHide={this.props.templateCloseHandler}
      >
        <TemplateHeader
          templateCloseHandler={this.props.templateCloseHandler}
          handleOpen={this.handleOpen}
          handleClose={this.handleClose}
          documentTitle={this.state.documentTitle}
          openEditModal={() => {
            this.setState({ showTabEditModal: true });
          }}
        />

        <div className="body">
          {this.state.editView ? (
            <div className="template-wrapper container-fluid">
              <TabsNavigation
                hasValidValue={this.hasValidValue()}
                addTabHandler={this.addTabHandler}
                changeTabHandler={this.changeTabHandler}
                content={this.state.content}
                contentLength={this.state.content.length}
                editView={this.state.editView}
                activeTab={this.state.activeTab}
                toggleEditHandler={this.toggleEditHandler}
                toggleViewHandler={this.toggleViewHandler}
              />
              <div className="row tab-content-wrapper mt-6" id="style-2">
                <div className="col-2">
                  <VerticalGroupBar
                    activeTab={this.state.activeTab}
                    activeTabSection={this.state.activeTabSection}
                    currentSection={this.state.currentSection}
                    updateState={this.handleCallback}
                  />
                </div>

                <div className="col-7">
                  <form>
                    {this.state.activeTab ? (
                      <TabName
                        error={this.state.errors}
                        name={this.state.currentTabName}
                        id={this.state.activeTab}
                        restrictedErrorId={this.state.activeTab + "restricted"}
                        uniqueErrorId={this.state.activeTab + "unique"}
                        updateTabNameHandler={(event) =>
                          this.updateTabNameHandler(event)
                        }
                      />
                    ) : null}
                    <DragDropContext
                      onDragStart={() =>
                        this.setState({
                          flag: false,
                        })
                      }
                      onDragEnd={(result) => this.onDragEnd(result)}
                    >
                      {this.state.activeTabSection.map((tabSec, index) => {
                        return (
                          <Droppable
                            key={tabSec.sectionId}
                            droppableId={tabSec.sectionId}
                            index={index}
                          >
                            {(provided) => {
                              return (
                                <div
                                  id={"v" + tabSec.sectionId}
                                  className={[
                                    "tab-content mt-8",
                                    this.state.currentSection ===
                                    tabSec.sectionId
                                      ? "active"
                                      : "",
                                  ].join(" ")}
                                  onClick={() =>
                                    this.setState(
                                      {
                                        flag: true,
                                      },
                                      this.changeSectionHandler(
                                        this.state.flag,
                                        tabSec.sectionId
                                      )
                                    )
                                  }
                                  {...provided.droppableProps}
                                  ref={provided.innerRef}
                                >
                                  <SectionTitle
                                    tabSec={tabSec}
                                    index={index}
                                    changeNameHandler={(event) =>
                                      this.updateSectionNameHandler(
                                        event,
                                        tabSec.sectionId
                                      )
                                    }
                                    deleteSectionHandler={() =>
                                      this.deleteSectionHandler(
                                        tabSec.sectionId
                                      )
                                    }
                                    error={this.state.errors}
                                  />

                                  {tabSec.sectionFields.map(
                                    (sectionItem, index) => {
                                      return (
                                        <Draggable
                                          key={sectionItem.fieldId}
                                          draggableId={sectionItem.fieldId}
                                          index={index}
                                        >
                                          {(provided, snapshot) => {
                                            return (
                                              <div
                                                className={[
                                                  this.state.currentFieldId ===
                                                  sectionItem.fieldId
                                                    ? "left-border"
                                                    : "",
                                                  snapshot.isDragging
                                                    ? "no-border"
                                                    : " ",
                                                ].join(" ")}
                                                // className="left-border"
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={{
                                                  userSelect: "none",

                                                  backgroundColor:
                                                    snapshot.isDragging
                                                      ? "#e4e4e4"
                                                      : "#ffffff",
                                                  ...provided.draggableProps
                                                    .style,
                                                }}
                                                onClick={(e) => {
                                                  this.updateFieldIdHandler(
                                                    e,
                                                    sectionItem.fieldId,
                                                    tabSec.sectionId
                                                  );
                                                }}
                                              >
                                                <SectionContent
                                                  sectionItem={sectionItem}
                                                  sectionId={tabSec.sectionId}
                                                  index={index}
                                                  updatedField={
                                                    this.updatedField
                                                  }
                                                  deleteFieldHandler={
                                                    this.deleteFieldHandler
                                                  }
                                                  addOptionHandler={
                                                    this.addOptionHandler
                                                  }
                                                  updateOptionValue={
                                                    this.updateOptionValue
                                                  }
                                                  deleteOptionsHandler={
                                                    this.deleteOptionsHandler
                                                  }
                                                  copyFieldHandler={
                                                    this.copyFieldHandler
                                                  }
                                                  changeFieldHandler={
                                                    this.changeFieldHandler
                                                  }
                                                  errors={this.state.errors}
                                                  mode="Template"
                                                />
                                              </div>
                                            );
                                          }}
                                        </Draggable>
                                      );
                                    }
                                  )}
                                  {provided.placeholder}
                                </div>
                              );
                            }}
                          </Droppable>
                        );
                      })}
                    </DragDropContext>
                  </form>
                </div>
                <div className="col-3">
                  <Tools
                    contentLenght={this.state.content.length}
                    addSectionHandler={this.addSectionHandler}
                    addFieldHandler={this.addFieldHandler}
                    addDateHandler={this.addDateHandler}
                    addOptionTypeFieldHandler={this.addOptionTypeFieldHandler}
                    deleteTabHandlerModal={() => {
                      this.setState({ showTabDeleteModal: true });
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <ViewMode
              editView={this.state.editView}
              content={this.state.content}
              changeTabHandler={this.changeTabHandler}
              activeTab={this.state.activeTab}
              toggleEditHandler={this.toggleEditHandler}
              toggleViewHandler={this.toggleViewHandler}
            />
          )}
        </div>

        <TemplateFooter
          templateCloseHandler={this.props.templateCloseHandler}
          draftTemplateHandler={this.draftTemplateHandler}
          createTemplateHandler={this.createTemplateHandler}
          editTemplate={this.props.editTemplate}
        />
        <EditDocumentTemplate
          errorMessage={this.state.errorName}
          templateTitle={this.state.templateTitle}
          templateDescription={this.state.templateDescription}
          showTabEditModal={this.state.showTabEditModal}
          tabEditSaveHandler={() => {
            this.setState({
              showTabEditModal: false,
              documentTitle: this.state.templateTitle,
              documentDescription: this.state.templateDescription,
            });
          }}
          tabEditCloseHandler={() => {
            this.setState({
              showTabEditModal: false,
              templateTitle: this.state.documentTitle,
              errorName: "",
              templateDescription: this.state.documentDescription,
            });
          }}
          handleInputValueChange={this.handleInputValueChange}
        />

        <TabDeleteModal
          showTabDeleteModal={this.state.showTabDeleteModal}
          tabDeleteCloseHandler={() => {
            this.setState({ showTabDeleteModal: false });
          }}
          tabDeleteYesHandler={this.deleteTabHandler}
          tabName={this.state.currentTabName}
        />
        {this.state.showTabDeleteModal ? (
          <div className="add-backdrop"></div>
        ) : null}
      </Modal>
    );
  }
}

export default NewTemplate;
